import { Tag } from 'antd';
import type { ColumnType } from 'antd/es/table';
import type { FilterValue } from 'antd/es/table/interface';
import { format } from 'date-fns';

import { type IParticipant } from '@/api/endpoints/schools/schoolParticipants';
import { DATE_FORMATTERS, EParticipantsStatus, PARTICIPANT_STATUS_TO_TAG_SETTINGS } from '@/shared/consts';

import styles from './ParticipantsList.module.scss';

export const getColumnsData = ({ filters }: { filters: Record<string, FilterValue | null> }) =>
  [
    {
      title: 'ФИО',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      filteredValue: filters.status || null,
      filters: [
        {
          text: PARTICIPANT_STATUS_TO_TAG_SETTINGS[EParticipantsStatus.AwaitingInvitation].text,
          value: EParticipantsStatus.AwaitingInvitation,
        },
        {
          text: PARTICIPANT_STATUS_TO_TAG_SETTINGS[EParticipantsStatus.PendingAuthorization].text,
          value: EParticipantsStatus.PendingAuthorization,
        },
        {
          text: PARTICIPANT_STATUS_TO_TAG_SETTINGS[EParticipantsStatus.Accepted].text,
          value: EParticipantsStatus.Accepted,
        },
      ],
      render: (_, { status }) => (
        <Tag
          className={styles.tag}
          color={PARTICIPANT_STATUS_TO_TAG_SETTINGS[status].color}
        >
          {PARTICIPANT_STATUS_TO_TAG_SETTINGS[status].text.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Дата зачисления',
      dataIndex: 'enrolling_date',
      key: 'enrolling_date',
      ellipsis: true,
      render: (_, { enrolling_date: enrollingDate }) => format(enrollingDate, DATE_FORMATTERS.DAY_MONTH_FULL_YEAR),
    },
  ] as ColumnType<IParticipant>[];
